import { Injectable } from '@angular/core';

/**
 * In-memory one-shot permit for `/diagnostic`.
 * Lives in the root injector so the landing CTA and the route guard share one instance.
 * SSR-safe: no window, cookies, localStorage, sessionStorage, URL query, or history.state.
 */
@Injectable({ providedIn: 'root' })
export class PublicDiagnosticLaunchService {
  #permit = false;

  /** Allows the next navigation into the public diagnostic route. */
  arm(): void {
    this.#permit = true;
  }

  /** Returns whether entry is allowed and immediately clears the permit. */
  consume(): boolean {
    const allowed = this.#permit;
    this.#permit = false;
    return allowed;
  }
}
